export interface IUser {
  userId?: number,
  user?:number
  companyId?: number;
  name?: string
  photo?: string
  areaId?: number,
  jobTitleId?: number,
  epsId?: number,
  arlId?: number,
  bloodTypeId?: number,
  username?: number,
  password?: string,
  email?: string,
  phone?: number,
  emergencyContact?: string,
  emergencyContactPhone?: number,
  countryId?: number,
  cityId?: number,
  address?: string,
  genderId?: number,
  dateJoining?: string,
  roleId?: number,
  role?:string;
  cv?: string,
  state?: number;
  area?:string;
  jobTitle?:string;
  hasPassword?:boolean;
  regionId?:number;
  passwordPrevious?: string;
  confirmPassword?: string;
  contactEps?: string;
  arlName?: string;
  epsName?: string;
  cityName?:string;
  areaName?:string;
  jobTitleName?:string;
}


export class User implements IUser {
  userId?: number;
  user?:number
  companyId?: number;
  name?: string;
  photo?: string;
  areaId?: number;
  jobTitleId?: number;
  epsId?: number;
  arlId?: number;
  bloodTypeId?: number;
  username?: number;
  password?: string;
  email?: string;
  phone?: number;
  emergencyContact?: string;
  emergencyContactPhone?: number;
  countryId?: number;
  //departmentId?: number;
  cityId?: number;
  address?: string;
  genderId?: number;
  dateJoining?: string;
  roleId?: number;
  role?:string;
  cv?: string;
  state?: number;
  area?:string;
  jobTitle?:string;
  hasPassword?:boolean;
  regionId?:number;
  passwordPrevious?: string;
  confirmPassword?: string;
  contactEps?: string;
  arlName?: string;
  epsName?: string;
  cityName?:string;
  areaName?:string;
  jobTitleName?:string;
}
